import { render, staticRenderFns } from "./GiftProductMobile.vue?vue&type=template&id=01720f92"
import script from "./GiftProductMobile.vue?vue&type=script&lang=js"
export * from "./GiftProductMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports